// extracted by mini-css-extract-plugin
module.exports = {"item":"GameItem_item__WImdu"};